export default "__VITE_ASSET__Bq8E3VrH__"